"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OBJECT_SPECS = void 0;
exports.specOf = specOf;
exports.objectCovers = objectCovers;
exports.footprint = footprint;
/**
 * Everything that can stand on the floor.
 *
 * Footprints are small on purpose: a bed is the only thing taller than two
 * tiles, which keeps a 16x12 home from being furniture with gaps in it.
 */
exports.OBJECT_SPECS = {
    bed: { label: 'Bed', width: 2, height: 3, solid: true, examine: 'A neatly made bed.' },
    table: { label: 'Table', width: 2, height: 2, solid: true, examine: 'A sturdy wooden table.' },
    chair: { label: 'Chair', width: 1, height: 1, solid: true, examine: 'A little wooden chair.' },
    lamp: { label: 'Lamp', width: 1, height: 1, solid: true, examine: 'A lamp, warm and humming.' },
    // Walkable: a rug the pet had to walk around would be worse than no rug.
    rug: { label: 'Rug', width: 2, height: 2, solid: false, examine: 'A soft round rug.' },
    chest: { label: 'Chest', width: 1, height: 1, solid: true, examine: 'A chest. Locked, for now.' },
    plant: { label: 'Plant', width: 1, height: 1, solid: true, examine: 'A cheerful potted plant.' },
};
function specOf(object) {
    return exports.OBJECT_SPECS[object.kind];
}
/** True when `object`'s footprint covers the tile at (x, y). */
function objectCovers(object, x, y) {
    const spec = specOf(object);
    return x >= object.x && x < object.x + spec.width && y >= object.y && y < object.y + spec.height;
}
/** Every tile an object stands on, top-left first. */
function footprint(object) {
    const spec = specOf(object);
    const tiles = [];
    for (let dy = 0; dy < spec.height; dy++) {
        for (let dx = 0; dx < spec.width; dx++) {
            tiles.push({ x: object.x + dx, y: object.y + dy });
        }
    }
    return tiles;
}
//# sourceMappingURL=objects.js.map